import { render, staticRenderFns } from "./CommonDiagnose.vue?vue&type=template&id=4b1cf8e9&scoped=true&"
import script from "./CommonDiagnose.vue?vue&type=script&lang=js&"
export * from "./CommonDiagnose.vue?vue&type=script&lang=js&"
import style1 from "./CommonDiagnose.vue?vue&type=style&index=1&id=4b1cf8e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1cf8e9",
  null
  
)

export default component.exports